import script from "./subscription.vue?vue&type=script&setup=true&lang=js"
export * from "./subscription.vue?vue&type=script&setup=true&lang=js"

import "./subscription.vue?vue&type=style&index=0&id=3be1a062&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be1a062"]])

export default __exports__